import React from 'react';
import { useTranslation } from 'react-i18next';
import { HighlightSection } from '../styles';

export const SectionTwo = ({ termData }) => {
    const { t } = useTranslation();
    const { 
        monthlySavings, 
        annualSavings, 
        totalSavings,  
        termInYears
    } = termData;

    return (
        <>
           <div>
                    {t('term_options.script.9')}
                    <strong style={{ textDecoration: 'underline'}}>
                        {monthlySavings} {t('term_options.script.10')}
                    </strong>
                    {t('term_options.script.11')} 
                    <strong style={{ textDecoration: 'underline'}}>
                        {annualSavings} {t('term_options.script.12')} 
                    </strong>
                    {t('term_options.script.13')}
                    <strong style={{ textDecoration: 'underline'}}>
                    {termInYears}{t('term_options.script.14')} 
                    </strong>
                    {t('term_options.script.15')} 
                    <strong style={{ textDecoration: 'underline'}}>
                        {totalSavings}
                    </strong>
                    {t('term_options.script.16')} 
                    <strong>{t('term_options.script.personal_goals')}</strong>
                    {t('term_options.script.kill_birds')}
           </div>
            <div>{t('term_options.script.17')}</div>
            <HighlightSection as='p'> 
                {t('term_options.script.18')} 
            </HighlightSection>
        </>
    );
};
